export const WINDOW_SPLIT_TREATMENTS = '__SPLIT_TREATMENTS__';
